/**
 * Modal edit date system component
 */

// React
import React, { Dispatch, FC, SetStateAction } from 'react';

// Material
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Components
import EditDateSystem from './editDateSystem';
import { useEditDateSystems } from './useEditDateSystems';

// Common styles
import { ButtonUpdate, WrapperForm } from 'styles';
import { DataSystemApplicationSettingCheck } from 'utils/types';

// Styled
const WrapperButton = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '80px',
});

// Type
type ModalEditDateSystemProps = {
  open: boolean;
  setOpenModelConfirm: any;
  setIsOpenModalBulkUpdateDate: any;
  setStartDateBulkUpdate: Dispatch<SetStateAction<Date | null>>;
  setEndDateBulkUpdate: Dispatch<SetStateAction<Date | null>>;
  handleClose: () => void;
  defaultValue?: DataSystemApplicationSettingCheck;
  listCreatedAtChecked: string[];
};

// Component
const ModalEditDateSystem: FC<ModalEditDateSystemProps> = ({
  open,
  setOpenModelConfirm,
  setIsOpenModalBulkUpdateDate,
  setStartDateBulkUpdate,
  setEndDateBulkUpdate,
  handleClose,
  defaultValue,
  listCreatedAtChecked,
}) => {
  const { control, errors, handleSubmit, handleUpdate } = useEditDateSystems({
    handleClose,
    setOpenModelConfirm,
    setIsOpenModalBulkUpdateDate,
    setStartDateBulkUpdate,
    setEndDateBulkUpdate,
    defaultValue,
    listCreatedAtChecked,
  });

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <WrapperForm onSubmit={handleSubmit(handleUpdate)}>
          <EditDateSystem control={control} errors={errors} />
          <WrapperButton>
            <ButtonUpdate
              onClick={handleClose}
              type="button"
              variant="outlined"
              sx={{ color: '#6EC8E2', border: '1px solid #6EC8E2' }}
            >
              戻る
            </ButtonUpdate>
            <ButtonUpdate type="submit" variant="contained">
              保存する
            </ButtonUpdate>
          </WrapperButton>
        </WrapperForm>
      </Modal>
    </div>
  );
};

export default ModalEditDateSystem;
